import moment from 'moment'
import 'moment/locale/en-gb'

export default function setupMoment(): void {
  moment.locale('en-GB')
}
